export default function getColor(isRay: boolean) {
  return isRay ? '#FF128E' : '#09c591'
}
